export default __webpack_public_path__ + "static/media/m2.1e389f82.png";